const workerReducer = (state, action) => {
  const {
    type,
    payload
  } = action;
  if (type === "worker/entity") {
    return {
      ...state,
      entity: payload
    }
  } else if (type === "worker/message") {
    return {
      ...state,
      message: payload
    }
  }
  return state;
}

export default workerReducer;
